import { Button } from '@/components';
import { Modal } from '@web3/base-components';
import { useProjectData } from '@/containers/aidol/hooks';
import { LotteryInfo } from '@/types/project';
import { appPath, hybirdOpen, justFormatNumber } from '@web3/base-utils';
import BigNumber from 'bignumber.js';
import { Input, Slider } from '@bfe/moly';
import { useParams, useFm, useHybirdWallet } from '@web3/base-hooks';
import { useScreenType } from '@/hooks/media';
import { scTrack, WEB3_EVENT } from '@web3/base-tracking';
import { Page } from '@/config/track-config';
import { formatAmount } from '@/utils';

import styles from './index.module.scss';
import CheckIcon from '@/assets/svg/project/check.svg';

interface Props {
  show: boolean;
  points: string;
  remainPoints: string;
  voteIsLoading: boolean;
  onChangePoints: (points: string) => void;
  beginVote: (points: string) => Promise<void>;
  onClose: () => void;
}

export const VoteModal = (props: Props) => {
  const {
    show,
    points,
    remainPoints,
    voteIsLoading,
    beginVote,
    onChangePoints,
    onClose,
  } = props;

  const fm = useFm();
  const { projectData } = useProjectData();
  const { locale } = useParams();
  const { isMobile } = useScreenType();
  const { mnemonicChainList } = useHybirdWallet();

  return (
    <Modal
      open={show}
      onCancel={onClose}
      footer={null}
      modal={false}
      size="medium"
      width={!isMobile && 480}
    >
      <div className={styles.container}>
        <div className={styles.avatarWrap}>
          <img className={styles.avatar} src={projectData.icon} />
          {/* <CheckIcon className={styles.checkIcon} /> */}
        </div>
        <div className={styles.title}>
          {fm('voteForProjectName', {
            projectName: projectData.name,
          })}
        </div>
        <Input
          value={points}
          numberControl={false}
          placeholder={
            +remainPoints > 0 ? `1-${formatAmount(remainPoints)}` : ''
          }
          type="number"
          autoComplete="off"
          onChange={(e) => {
            const value = e.target.value;
            if (/\./g.test(value)) return;
            if (new BigNumber(value).isLessThan(1)) return;
            if (new BigNumber(value).isGreaterThan(remainPoints)) return;

            onChangePoints(e.target.value);
          }}
          className={styles.input}
        />
        <div className={styles.sliderArea}>
          <Slider
            value={
              +new BigNumber(points)
                .div(remainPoints)
                .times(100)
                .integerValue(BigNumber.ROUND_CEIL)
                .toString()
            }
            className={styles.slider}
            onChange={(v: number) => {
              const formatValue = new BigNumber(remainPoints)
                .times(`${v}`)
                .div(100)
                .integerValue(BigNumber.ROUND_CEIL)
                .toString();

              console.log('formatValue', remainPoints, v, formatValue);
              onChangePoints(formatValue);
            }}
            step={1}
            min={1}
            marks={{
              0: '0%',
              25: '25%',
              50: '50%',
              75: '75%',
              100: '100%',
            }}
          />
        </div>
        <div className={styles.desc}>
          <div className={styles.descText}>
            <div>{fm('remainingVotingPoints')}</div>
            <div>{formatAmount(remainPoints)}</div>
          </div>
          {/* {canTradeMore && <div>{fm('contributeByTrading')}</div>} */}
        </div>
        <div className={styles.pointsArea}>
          <div className={styles.pointsRow}>
            <div className={styles.pointsLabel}>{fm('myContribute')}</div>
            <div className={styles.pointsValue}>
              {formatAmount(`${projectData.userProjectPoint}`)}
            </div>
          </div>
          <div className={styles.pointsRow}>
            <div className={styles.pointsLabel}>{fm('myRank')}</div>
            <div className={styles.pointsValue}>
              {projectData.userPointRank}
            </div>
          </div>
        </div>
        <div className={styles.buttonArea}>
          <Button
            className={styles.button}
            variant="primary"
            size={isMobile ? 'small' : 'middle'}
            onClick={() => {
              scTrack(WEB3_EVENT.Web3UserClick, {
                page_name: Page.DeailPage,
                spmName: projectData.name,
                button_name:
                  projectData.remainLotteryCount > 0 ? 'Vote&Lottery' : 'Vote',
              });

              // window.open(`/${locale}${appPath}/profile`, '_blank');
              beginVote(points);
            }}
            disabled={+remainPoints === 0}
            loading={voteIsLoading}
          >
            {projectData.remainLotteryCount > 0
              ? fm('voteAndLottery')
              : fm('vote')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
